import { Inject, Injectable } from "@angular/core";
import { AuthenticateTransactionRequest, EncryptedPaymentRequest, HostedPaymentPageRequest } from "@models/requests/payment-request.model";
import {
  CorporateCreditCardFeeResponse,
  EncryptedPaymentResponse,
  HostedPaymentPageResponse,
  SongbirdInitResponse
} from "@models/responses/payment-api-response.model";
import { EnvironmentService } from "@services/environment-service/environment.service";
import { map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { OrchestrationPaymentStatuses } from "@models/payment.model";
import {CreditCardFeeMap} from "../../typings/credit-card-type";
import {request} from "posthog-js/lib/src/request";

@Injectable({
  providedIn: 'root',
})
export class OrchestrationService {
  private static readonly PAYMENTS_ENDPOINT = 'v1/payments';
  private static readonly TRANSACTIONS_ENDPOINT = 'v1/transactions';
  private static readonly CARD_ENDPOINT = 'v1/card';

  constructor(@Inject(HttpClient) private readonly httpClient: HttpClient) {}

  getHostedPaymentPageUrl(request: HostedPaymentPageRequest): Observable<HostedPaymentPageResponse> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.PAYMENTS_ENDPOINT}/hosted`;
    return this.httpClient.post<HostedPaymentPageResponse>(endpoint, request);
  }

  getPaymentStatus(paymentStatusReference : string) : Observable<OrchestrationPaymentStatuses> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.TRANSACTIONS_ENDPOINT}/status`;
    return this.httpClient.post<{status: OrchestrationPaymentStatuses}>(endpoint, {paymentStatusReference}).pipe(map(statusObject => statusObject.status));
  }

  getSongbirdJwt(): Observable<SongbirdInitResponse> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.PAYMENTS_ENDPOINT}/encrypted`;
    return this.httpClient.get<SongbirdInitResponse>(endpoint);
  }

  commitEncryptedPayment(request: EncryptedPaymentRequest) : Observable<EncryptedPaymentResponse> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.PAYMENTS_ENDPOINT}/encrypted`;
    return this.httpClient.post<EncryptedPaymentResponse>(endpoint, request);
  }

  authenticate(request: AuthenticateTransactionRequest): Observable<void> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.TRANSACTIONS_ENDPOINT}/authenticate`;
    return this.httpClient.post<void>(endpoint, request);
  }

  loadCreditCardFees(): Observable<{fees: CreditCardFeeMap}> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.CARD_ENDPOINT}/fee/rates`;
    return this.httpClient.get<{ fees: CreditCardFeeMap }>(endpoint);
  }

  checkCreditCardFee(cleanSearch: boolean = false, instantApply: boolean, cardBin?: string): Observable<CorporateCreditCardFeeResponse> {
    const endpoint = `${EnvironmentService.environment.apiPaymentsUrl}${OrchestrationService.CARD_ENDPOINT}/check`;
    return this.httpClient.post<CorporateCreditCardFeeResponse>(endpoint, {cardBin, cleanSearch, instantApply});
  }
}
